import { BaseNodeModel } from "@/models/nodes/BaseNodeModel";

import type { DecoratorTypeValue } from "@/components/suggestions/providers/data/types";
import type { DocumentModel } from "@/models/DocumentModel";
import type { NodeId } from "@/models/nodes/types";
import type { VisitableNode, NodeVisitor } from "@/models/nodes/visitors/NodeVisitor";
import type { DecoratorNodeProps, DecoratorNodeConstructorProps } from "@corca/data";

export class DecoratorNodeModel extends BaseNodeModel<DecoratorNodeProps> implements VisitableNode {
  static type = "decorator" as const;

  type = DecoratorNodeModel.type;

  protected fillRequiredProps(props: DecoratorNodeConstructorProps): DecoratorNodeProps {
    this.reportMissingProps(props, ["name"]);
    return { ...props, name: props.name ?? "vector" };
  }

  static create(
    doc: DocumentModel,
    name: DecoratorTypeValue,
    props: Omit<DecoratorNodeConstructorProps, "name"> = {},
    id?: NodeId,
  ) {
    return new DecoratorNodeModel(doc, id, { ...props, name });
  }

  get name(): DecoratorTypeValue {
    return this.props.name;
  }

  accept<R>(visitor: NodeVisitor<R>): R {
    return visitor.visitDecoratorNode(this);
  }
}
